import ApiClient from '../ApiClient';

class CrmLossReasonsAPI extends ApiClient {
    constructor() {
        super('crm/loss_reasons', { accountScoped: true });
    }
}
export default new CrmLossReasonsAPI();
